export default __webpack_public_path__ + "ea5acf3619e3ab65721592096fc91e23.svg";